var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDefaultAvatarA = function SvgDefaultAvatarA(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 55.3c3.8 0 6.3-.6 6.3-1.7 0-.8-.9-1.1-3.5-1.2-.5-.8 0-3 .9-5.6.2-.5.4-1 .6-1.6 2-.1 3.7-.2 5.7-.2 1.9 0 3.9 0 6 .2l.3.7c1.3 3.7 1.9 5.9 1.5 6.6-2.8 0-3.8.3-3.8 1.2 0 1 2.1 1.6 6.8 1.6 4.6 0 6.8-.5 6.8-1.6 0-.8-.9-1.1-2.8-1.3-.6-.4-1.1-.9-2.4-4.2-2.4-6.1-6.8-16.2-9-20.7-.9-1.9-1.7-2.6-3.1-2.6-1.3 0-2.3.9-2.4 2.2-.2.8-.3 1.6-.7 2.9-1 2.6-4.5 11.1-7.1 17.5-1.3 3.1-2.1 4.4-2.9 5-2.1.2-3 .5-3 1.3 0 .9 2.2 1.5 5.8 1.5zm5.4-13c1.4-3.5 3.1-7.6 4.6-11.1 1.7 3.5 3.4 7.2 5 11.1-1.8 0-3.4-.1-4.9-.1-1.8 0-3.1 0-4.7.1z"
  })));
};
export default SvgDefaultAvatarA;